// Дизайн токените на страницата „Маркиране" в Конфигурация (OrderingSettingsPage)
// — заварен inline стил в TopBar-а и модала за резултат; картите са в Tailwind.
export const R = {
  bg: "var(--color-canvas)",
  surface: "var(--color-surface)",
  border: "var(--color-shade-2)",
  borderMed: "var(--color-shade-3)",
  text: "var(--color-ink)",
  textSoft: "var(--color-body)",
  textMuted: "var(--color-muted)",
  ink: "var(--color-ink)",
  // Плътни акцентни фонове — еднакви в двете теми.
  brand: "#D97706",
  brandDeep: "#B45309",
  brandTint: "var(--color-brand-tint)",
  danger: "#DC2626",
  dangerDeep: "#B91C1C",
  dangerTint: "var(--color-danger-tint)",
  mono: '"JetBrains Mono", ui-monospace, monospace',
};
